import React, { PropsWithChildren } from 'react'
import classNames from 'classnames'

import IconButton from '../../../../global/iconButton/IconButton'
import { RadioButton } from '../../../../global/radioButton/RadioButton'
import { useWindowResize } from '../../../../utils/domUtils'
import { Text } from '../../../Typography/Typography'
import type { CommonModalProps } from '../types'
import { RadioModalDesktop } from './RadioModalDesktop'
import { RadioModalMobile } from './RadioModalMobile'

import styles from './RadioOptionModal.module.scss'

interface RadioModalProps extends CommonModalProps {
  description?: React.ReactNode
  options: React.ReactNode[]
  isLoading?: boolean
  renderFooter?(props: RadioModalProps): React.ReactNode[]
}

export const RadioModal: React.FC<RadioModalProps> & {
  Option: React.FC<RadioOptionModalProps>
  IconOption: React.FC<RadioIconOptionModalProps>
} = (props) => {
  const isMobile = useWindowResize()
  return isMobile ? <RadioModalMobile {...props} /> : <RadioModalDesktop {...props} />
}

interface RadioOptionModalProps extends PropsWithChildren {
  label?: string | React.ReactNode
  checked?: boolean
  disabled?: boolean
  hint?: string
  onClick?(): void
}

RadioModal.Option = (props) => {
  const { label, hint, checked, disabled, children, onClick, ...restProps } = props

  return (
    <div className={styles.option}>
      <label
        className={classNames(styles.radioLabel, {
          [styles.disabled]: disabled,
        })}
      >
        <RadioButton {...restProps} checked={checked} disabled={disabled} onClick={onClick}>
          <div className={styles.label}>{label}</div>
          <div className={styles.hint}>{hint}</div>
          <div className={styles.content}>{children}</div>
        </RadioButton>
      </label>
    </div>
  )
}

interface RadioIconOptionModalProps extends PropsWithChildren {
  label: string | React.ReactNode
  icon: React.ReactNode
  onClick?(): void
}

RadioModal.IconOption = (props) => {
  const { label, icon, onClick } = props

  return (
    <div className={styles.iconOption}>
      <label className={styles.radioLabel}>
        <IconButton align='left' onClick={onClick} fullWidth>
          <div className={styles.label}>
            <span className={styles.labelIcon}>{icon}</span>
            <Text>{label}</Text>
          </div>
        </IconButton>
      </label>
    </div>
  )
}
